export default "__VITE_ASSET__DdopAHfz__"